define('services/htmlService',['require','utils'],function(require) {
    'use strict';
    var utils = require('utils');

    var htmlService = function() {
        this.nodeWhiteList = /^#document|p|div|h[1-6]|img|ol|ul|li|br|b|dt|dl|em|hr|i|strike|strong|table|tbody|thead|tr|td|th$/i;
        this.attributeWhiteList = /^alt|src$/i;
        this.attribute = /\s(([a-z]+)="[^"]*")/gim;
        this.containsHtml = /[><]/;
        this._cleanHtmlNodeHandler = this._cleanHtmlNode.bind(this);
        this._attributeReplacerHandler = this._attributeReplacer.bind(this);
    };
    var proto = htmlService.prototype;

    /**
     * uses jquery's parse html func to recursively iterate through the nodes and take only whitlisted ones and leave the content of non-whitelisted ones. 
     * Note that for some reason the text property doesn't html encode, but the html property (except outerHTML) does: todo: look up why
     * @param {string} htmlString 
     * @returns {string} 
     */
    proto.cleanHtmlString = function(htmlString) {
        if (!this.containsHtml.test(htmlString)) {
            return htmlString;
        }
        var html = $.parseHTML(htmlString);
        return html.map(this._cleanHtmlNodeHandler).join('');
    };

    proto._cleanHtmlNode = function(node) {
        if (!utils.isNullOrWhiteSpace(node.innerText)) {
            node.innerText = this.cleanHtmlString(node.innerText);
        }
        var clean = (this.nodeWhiteList.test(node.nodeName) ? node.outerHTML : node.innerText) || '';
        return clean;
    };

    /**
     * get rid of any attributes that aren on our whitlist
     * @param {string} xmlString 
     * @returns {string} 
     */
    proto.cleanAttributes = function(xmlString) {
        return xmlString.replace(this.attribute, this._attributeReplacerHandler);
    };

    proto._attributeReplacer = function(match, attribute, attributeName, offset, string) {
        if (this.attributeWhiteList.test(attributeName)) {
            return match;
        }
        return '';
    };

    ///**
    // * recursively clean up detail nodes, only allowing whitelisted tags and attributes.
    // * tests:
    // *          -simple no tags: 'some stuff' --> 'some stuff'
    // *          -simple elements don't cause issues: '<br><br/>' --> '<br><br/>'
    // *          -complex nested: '<noscript><div style="width:230px;"><font color="blue">ok this should remain within a plain div.</font></div></noscript>' --> <div>ok this should remain within a plain div.</div>
    // * 
    // * @param {string} xmlString
    // * @returns {string} 
    // */
    //proto.cleanXmlString = function (xmlString) {
    //    if (!containsHtml.test(xmlString)) {
    //        return xmlString;
    //    }
    //    var xml = $.parseXML(xmlString);
    //    var output = '';
    //    for (var i = 0; i < xml.childNodes.length; i++) {
    //        var node = xml.childNodes[i];
    //        node.innerHTML = cleanXmlString(node.innerHTML);
    //        var clean = nodeWhiteList.test(node.nodeName) ? node.outerHTML : node.innerHTML;
    //        output += clean;
    //    }
    //    return output;
    //};

    return htmlService;
});

